var PREFIXED_START_TIME = 7;
var RESPONSIVE_START_TIME = 12;
var datesToReplaceZero = ['午後0時', 'ÖS 0', '下午0时'];
export function getDatesToRemove(time) {
    return [
        "".concat(time, " AM"),
        "".concat(time, " UHR AM"),
        "".concat(time, " DOP"),
        "\u5348\u524D".concat(time, "\u6642"),
        "\uC624\uC804 ".concat(time, "\uC2DC"),
        "".concat(time, " FM"),
        "\u00D6\u00D6 ".concat(time),
        "\u4E0A\u5348".concat(time, "\u65F6"),
        "".concat(time, " \u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07"),
        "".concat(time, " \u0414\u041F"),
        "".concat(time, " SA"),
    ];
}
export function testRegex(str) {
    return function (regex) { return regex.test(str); };
}
export default function getLeftSideTimes(timeText, is24format, isResponsive) {
    var test = testRegex(timeText);
    var timeTextRes = timeText;
    if (is24format) {
        timeTextRes = timeTextRes.replace('.', ':');
        if (timeTextRes.length > 4 && timeTextRes[0] === '0') {
            timeTextRes = timeTextRes.slice(1);
        }
        if (isResponsive) {
            if (timeTextRes === '24:00' || timeTextRes === '0:00') {
                timeTextRes = '';
            }
        }
        else {
            if (timeTextRes === "".concat(PREFIXED_START_TIME, ":00")) {
                timeTextRes = '';
            }
        }
    }
    else {
        timeTextRes = timeTextRes.replaceAll('. ', '').toUpperCase();
        timeTextRes = timeTextRes.replaceAll('.', '');
        if (timeTextRes[0] === '0' ||
            datesToReplaceZero.includes(timeTextRes) ||
            (test(/אחה״צ/) && test(/0/) && !test(/10/))) {
            timeTextRes = timeTextRes.replace('0', '12');
        }
        if (isResponsive) {
            if (test(/0/) && !test(/10/)) {
                timeTextRes = timeTextRes.replace('0', '12');
            }
            if (getDatesToRemove(RESPONSIVE_START_TIME).includes(timeTextRes) ||
                (test(/לפנה״צ/) && test(/0/) && !test(/10/))) {
                timeTextRes = '';
            }
        }
        else {
            if (getDatesToRemove(PREFIXED_START_TIME).includes(timeTextRes) ||
                (test(/לפנה״צ/) && test(/7/))) {
                timeTextRes = '';
            }
        }
    }
    return timeTextRes;
}
//# sourceMappingURL=getLeftSideTimes.js.map